var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.375 33.6328H25.625C15.9003 33.6456 8.02063 41.5253 8.00781 51.25V153.75C8.02063 163.475 15.9003 171.354 25.625 171.367H179.375C189.1 171.354 196.979 163.475 196.992 153.75V51.25C196.979 41.5253 189.1 33.6456 179.375 33.6328ZM17.6172 68.8672H187.383V84.8828H17.6172V68.8672ZM25.625 43.2422H179.375C183.795 43.2486 187.376 46.8297 187.383 51.25V59.2578H17.6172V51.25C17.6236 46.8297 21.2047 43.2486 25.625 43.2422ZM179.375 161.758H25.625C21.2047 161.751 17.6236 158.17 17.6172 153.75V94.4922H187.383V153.75C187.376 158.17 183.795 161.751 179.375 161.758ZM64.0625 136.133H38.4375C35.7853 136.133 33.6328 138.285 33.6328 140.938C33.6328 143.59 35.7853 145.742 38.4375 145.742H64.0625C66.7147 145.742 68.8672 143.59 68.8672 140.938C68.8672 138.285 66.7147 136.133 64.0625 136.133ZM128.125 136.133H89.6875C87.0353 136.133 84.8828 138.285 84.8828 140.938C84.8828 143.59 87.0353 145.742 89.6875 145.742H128.125C130.777 145.742 132.93 143.59 132.93 140.938C132.93 138.285 130.777 136.133 128.125 136.133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditos);
export default __webpack_public_path__ + "static/media/iconCreditos.5400f59603e5f4d064f3274e7d065e28.svg";
export { ForwardRef as ReactComponent };